@if(sideKeyboard()) {
    <app-cashregister-keyboard
        class="tw-block tw-border-solid tw-border tw-border-gray-200 tw-rounded-lg tw-p-2"
        [principalActionButton]="principalActionButton"
        [actionButtons]="actionButtons"
        [fastPaymentsButtons]="fastPaymentsButtons"
        [sale]="sale"
        (addNewItemToSaleEmitter)="addItemToSaleHandler($event)"
        (activateSideKeyboard)="toggleSideKeyboard($event)"
    />
} @else {
    <app-active-sale-action-buttons
        [ngClass]="actionButtonsHeight"
        [class.tw-h-full]="isMobilePortrait()"
        [saleAmount]="saleAmount"
        [isLoading]="isLoading()"
        [layoutActionButtons]="layoutActionButtons"
        [principalActionButton]="principalActionButton"
        [actionButtons]="actionButtons"
        [fastPaymentsButtons]="fastPaymentsButtons"
        [isHidePrices]="!showPrices"
    />
}